import type { BoggleBadgeDefinition } from '~/boggle/config/badges/types'

/**
 * Resolves bracket groups in a tiered badge description template to the value
 * for the viewed tier, e.g. `Play [6 / 8 / 10] words` → `Play 8 words` for tier II.
 */
export function formatBadgeDescriptionTemplate(
  template: string,
  tierIndex: number,
): string {
  return template.replace(/\[(.*?)\]/g, (_match, group: string) => {
    const parts = group.split('/').map(part => part.trim())
    const value = parts[tierIndex - 1] ?? parts[parts.length - 1] ?? ''
    return value
  })
}

/** Returns display description; tiered defs store pre-resolved copy on `description`. */
export function formatBadgeDescription(definition: BoggleBadgeDefinition): string {
  return definition.description
}
